<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body pb-8">
				<div class="container">
					<div class="mb-3">
						<ng-select id="kind" name="kind" [(ngModel)]="filters.kind" placeholder="Typ">
							@for (item of kinds; track item.name) {
								<ng-option [value]="item.value">{{ item.name }}</ng-option>
							}
						</ng-select>
					</div>
					<div class="form-floating mb-3">
						<ng-select id="isActive" name="isActive" [(ngModel)]="filters.isActive" placeholder="Aktywna">
							<ng-option value="">(wszystkie)</ng-option>
							<ng-option value="true">Tak</ng-option>
							<ng-option value="false">Nie</ng-option>
						</ng-select>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="row row-full">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
